export default __webpack_public_path__ + "static/media/default.a8148f847087307186d017bafa9193d5.svg";